export default "https://storage.googleapis.com/prepweb-prod/dist/227547491e9f22539ef06e2c35e7740a.svg";